export const inputCls =
  "w-full bg-white border border-[#e5e0d8] text-[#1c1a17] rounded-sm px-3 py-2.5 text-sm focus:outline-none focus:ring-1 focus:ring-[#234333] focus:border-[#234333]";

export const MEETING_STATUSES = ["Scheduled", "Completed", "Cancelled", "Postponed"];
export const DOC_CATEGORIES = ["Notice", "Agenda", "MoM", "Resolution", "Supporting"];
export const ATTENDANCE_STATUSES = ["Present", "Absent", "Leave"];
export const QUARTERS = [
  { value: 1, label: "Q1 (Apr–Jun)" },
  { value: 2, label: "Q2 (Jul–Sep)" },
  { value: 3, label: "Q3 (Oct–Dec)" },
  { value: 4, label: "Q4 (Jan–Mar)" },
];

export function fmtDate(d) {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return d;
  }
}

export function statusBadgeClass(status) {
  switch (status) {
    case "Completed":
      return "bg-[#234333]/10 text-[#234333] border-[#234333]/30";
    case "Cancelled":
      return "bg-[#9e2a2b]/10 text-[#9e2a2b] border-[#9e2a2b]/30";
    case "Postponed":
      return "bg-[#d4af37]/10 text-[#8a6d1d] border-[#d4af37]/30";
    default:
      return "bg-[#6b655b]/10 text-[#6b655b] border-[#6b655b]/30";
  }
}
